import React from 'react';
import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './generalErrorPage.scss';
import storeManager from '../../store/StoreManager';
import sessionConstants from '../../constants/SessionConstants';

const MODE_MESSAGES = {
    [sessionConstants.MODE_QUESTION_SET]: {
        title: 'ForbiddenItemsPage.title',
        message: 'ForbiddenItemsPage.message',
    },
    [sessionConstants.MODE_SECTION]: {
        title: 'ForbiddenItemsPage.CBTitle',
        message: 'ForbiddenItemsPage.CBMessage',
    },
};

class ForbiddenItemsPage extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    render() {
        const mode = storeManager.getState().session.mode;
        if (!MODE_MESSAGES[mode]) {
            return null;
        }
        const { title, message } = MODE_MESSAGES[mode];


        return (
            <div className={styles.forbiddenItemsPage} role="main">
                <i className="fa fa-eye-slash fa-2x" />
                <p className="title">{t(title)}</p>
                <p className="message">{t(message)}</p>
            </div>
        );
    }
}

export default ForbiddenItemsPage;
